import React, { useMemo } from 'react';
import { SelectArrayInput, useGetList } from 'react-admin';

const GroupFilter = () => {
  const { data, isLoading } = useGetList('groups', { filter: { active: true }, pagination: { page: 1, perPage: 200 } });

  const choices = useMemo(() => [
    { id: 'none', name: 'None' },
    ...data ? data.map((group) => ({
      id: group.id,
      name: group.name,
    })) : [],
  ], [data]);

  if (isLoading) return null;

  return (
    <SelectArrayInput
      choices={choices}
    />
  );
};

export default GroupFilter;
